<script lang="ts">
  export let visible: boolean = false;
  export let customClass: string = "";
</script>

<div
  class="
    flex w-full h-full justify-center items-center {customClass} {!visible
    ? 'hidden'
    : ''}
  "
>
  <div class="spinner spinOuter">
    <div class="inner spinInner"></div>
  </div>
</div>

<style lang="postcss">
  .spinner {
    width: 72px;
    height: 72px;
    position: relative;
    border-top: 4px solid #cadfe0;
    border-right: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 4px solid transparent;
    border-radius: 50%;
  }

  .spinOuter {
    animation: spinRight 1.5s linear infinite;
  }

  .spinInner {
    animation: spinLeft 4.5s linear infinite;
  }

  .inner {
    width: 60px;
    height: 60px;
    position: absolute;
    left: 4px;
    top: 4px;
    border-top: 4px solid #cadfe0;
    border-right: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 4px solid transparent;
    border-radius: 50%;
  }

  @keyframes spinRight {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinLeft {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(720deg);
    }
  }
</style>
